import { getExperiment } from '@eventbrite/statsig';

export interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

export enum CategoryBrowseBucketsNewAdsExperimentValues {
    control = 'control',
    ad1 = 'ad1',
}

export const CategoryBrowseBucketsNewAdsExperiment: Experiment<
    typeof CategoryBrowseBucketsNewAdsExperimentValues
> = {
    name: 'category_browse_buckets_new_ads',
    paramName: 'value',
    values: CategoryBrowseBucketsNewAdsExperimentValues,
};

export const categoryBrowseBucketsNewAdsExperiment = () =>
    getExperiment(
        CategoryBrowseBucketsNewAdsExperiment.name,
        CategoryBrowseBucketsNewAdsExperiment.paramName,
        CategoryBrowseBucketsNewAdsExperiment.values.control,
    );
